import { render, staticRenderFns } from "./occupancy.vue?vue&type=template&id=1ec27e56&"
import script from "./occupancy.vue?vue&type=script&lang=js&"
export * from "./occupancy.vue?vue&type=script&lang=js&"
import style0 from "./occupancy.vue?vue&type=style&index=0&id=1ec27e56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports